export default __webpack_public_path__ + "static/media/bj.6865df98.svg";